import React from 'react';
import { __ } from 'first-intl';
import { TRACK_ID } from '@hugendubel/tracking_client';
import { A } from '@hugendubel/react-basic';
import { RoutingUrl } from '../../appRoutes';
import { BonusPointsDetails } from '../bonus/BonusPointsDetails';

export const IntroSection: React.FC = () => (
    <div className="row intro">
        <div className="col-sm-8">
            <header>
                <h1>{__(process.env.IS_HUDU ? 'intro.title.hudu' : 'intro.title.eBook')}</h1>
                <p>{__({ id: 'intro.text', values: { br: <br /> } })}</p>
            </header>

            <p>
                <A
                    className="btn btn-simple btn-icon-right icon-arrow-right"
                    trackId={TRACK_ID('2019-07-31 04:03:32')}
                    href={RoutingUrl.bonusPointHistory()}
                >
                    {__('points.historyLink')}
                </A>
            </p>
        </div>
        <div className="col-sm-4 align-right">
            <BonusPointsDetails />
        </div>
    </div>
);
